import { classSet, NewModal } from '@platform/ui-library';
import { FC, ReactNode, useState } from 'react';
import { LoginState } from './login-state';
import { LoginPasswordForm } from './login-password-form';
import { LoginCodeForm } from './login-code-form';

export type LoginModalProps = {
  onComplete: () => void;
};

export const LoginModal: FC<LoginModalProps> = ({ onComplete }) => {
  const [state, setState] = useState<LoginState>({
    enableRememberMe: false,
    password: '',
    username: '',
    validUsernameAndPassword: false
  });

  const backdropClass = (location.pathname.startsWith('/home')) ? (
    'ui-modal-hide-backdrop'
  ) : null;

  let content: ReactNode;
  content = (!state.validUsernameAndPassword) ? (
    <LoginPasswordForm
      onComplete={onComplete}
      setState={setState}
      state={state}
    />
  ) : (
    <LoginCodeForm
      onComplete={onComplete}
      setState={setState}
      state={state}
    />
  );

  return (
    <NewModal className={classSet(['ui-box-small', backdropClass])} isOpen>
      {content}
    </NewModal>
  );
};
